import React from "react";

export default function JS_Polymorphism() {
  return (
    <div className="tutorial-container">
      <h1>JS Polymorphism</h1>
      <p>
        This tutorial explains the concept of JS Polymorphism in JavaScript
        OOPs.
      </p>
    </div>
  );
}
